export const translations = {
  en: {
    hero: {
      title: "AI-Powered Healthcare Triage for Everyone, Everywhere",
      subtitle: "Tibbbi helps healthcare providers deliver faster, more accurate patient assessments in 30+ languages, reducing wait times and improving care quality worldwide.",
      whatsapp: "Chat on WhatsApp",
      messenger: "Chat on Messenger",
      badges: {
        hipaa: "HIPAA Compliant",
        trusted: "Trusted by 100+ Providers"
      }
    },
    stats: {
      timeReduction: "Reduced Triage Time",
      accuracy: "Diagnostic Accuracy",
      availability: "Available",
      languages: "Languages"
    },
    features: {
      title: "Why Healthcare Providers Choose Tibbbi",
      subtitle: "Transform your practice with intelligent automation",
      triage: {
        title: "Intelligent Triage",
        description: "AI-powered assessment tool that asks the right questions, gathering comprehensive patient history in their preferred language."
      },
      efficiency: {
        title: "Save Valuable Time",
        description: "Reduce intake time by 50% while ensuring no critical information is missed. Focus on patient care, not paperwork."
      },
      multilingual: {
        title: "Break Language Barriers",
        description: "Seamlessly communicate with patients in 30+ languages including Arabic, Hebrew, French, English, Spanish, Mandarin, and more. Perfect for diverse global communities."
      },
      secure: {
        title: "Secure & Compliant",
        description: "HIPAA-compliant platform with enterprise-grade security. Your patient data is encrypted and protected at all times."
      }
    },
    providerCTA: {
      title: "Is Your Healthcare Provider Using Tibbbi?",
      subtitle: "Help your doctor save time and provide better care with AI-powered triage",
      button: "Refer Your Provider - Get $50 Gift Card",
      incentive: "✨ Earn $50 when your provider signs up!"
    },
    howItWorks: {
      title: "How Tibbbi Works",
      steps: [
        {
          title: "Patient Starts Assessment",
          description: "Patients begin their health assessment in their preferred language through a simple, guided interface."
        },
        {
          title: "AI Gathers Information",
          description: "Our AI asks relevant follow-up questions, ensuring comprehensive data collection without overwhelming the patient."
        },
        {
          title: "Provider Reviews Summary",
          description: "Healthcare providers receive a structured, actionable summary, ready for immediate clinical decision-making."
        }
      ]
    },
    footer: {
      copyright: "© 2024 Tibbbi. All rights reserved.",
      startAssessment: "Start Assessment",
      contact: "Contact Support"
    }
  },
  ar: {
    hero: {
      title: "الفرز الصحي المدعوم بالذكاء الاصطناعي للجميع، في كل مكان",
      subtitle: "يساعد طبّي مقدمي الرعاية الصحية على تقديم تقييمات أسرع وأكثر دقة للمرضى بأكثر من 30 لغة، مما يقلل أوقات الانتظار ويحسن جودة الرعاية في جميع أنحاء العالم.",
      whatsapp: "المحادثة على واتساب",
      messenger: "المحادثة على ماسنجر",
      badges: {
        hipaa: "متوافق مع HIPAA",
        trusted: "موثوق من 100+ مقدم رعاية"
      }
    },
    stats: {
      timeReduction: "تقليل وقت الفرز",
      accuracy: "دقة التشخيص",
      availability: "متاح",
      languages: "لغات"
    },
    features: {
      title: "لماذا يختار مقدمو الرعاية الصحية طبّي",
      subtitle: "حوّل ممارستك الطبية بالأتمتة الذكية",
      triage: {
        title: "فرز ذكي",
        description: "أداة تقييم مدعومة بالذكاء الاصطناعي تطرح الأسئلة الصحيحة، وتجمع التاريخ الطبي الشامل للمريض بلغته المفضلة."
      },
      efficiency: {
        title: "وفر الوقت الثمين",
        description: "قلل وقت الاستقبال بنسبة 50% مع ضمان عدم تفويت أي معلومات حرجة. ركز على رعاية المرضى، وليس الأعمال الورقية."
      },
      multilingual: {
        title: "كسر حواجز اللغة",
        description: "تواصل بسلاسة مع المرضى بأكثر من 30 لغة بما في ذلك العربية والعبرية والفرنسية والإنجليزية والإسبانية والصينية وأكثر. مثالي للمجتمعات العالمية المتنوعة."
      },
      secure: {
        title: "آمن ومتوافق",
        description: "منصة متوافقة مع HIPAA مع أمان على مستوى المؤسسات. بيانات مرضاك مشفرة ومحمية في جميع الأوقات."
      }
    },
    providerCTA: {
      title: "هل يستخدم مقدم الرعاية الصحية الخاص بك طبّي؟",
      subtitle: "ساعد طبيبك على توفير الوقت وتقديم رعاية أفضل مع الفرز المدعوم بالذكاء الاصطناعي",
      button: "أحل مقدم الرعاية الخاص بك - احصل على 50$ رصيد",
      incentive: "✨ اكسب 50$ عندما يشترك مقدم الرعاية الخاص بك!"
    },
    howItWorks: {
      title: "كيف يعمل طبّي",
      steps: [
        {
          title: "يبدأ المريض التقييم",
          description: "يبدأ المرضى تقييمهم الصحي بلغتهم المفضلة من خلال واجهة بسيطة وموجهة."
        },
        {
          title: "الذكاء الاصطناعي يجمع المعلومات",
          description: "يطرح الذكاء الاصطناعي لدينا أسئلة متابعة ذات صلة، مما يضمن جمع بيانات شاملة دون إرهاق المريض."
        },
        {
          title: "مقدم الرعاية يراجع الملخص",
          description: "يتلقى مقدمو الرعاية الصحية ملخصًا منظمًا وقابلاً للتنفيذ، جاهزًا لاتخاذ القرارات السريرية الفورية."
        }
      ]
    },
    footer: {
      copyright: "© 2024 طبّي. جميع الحقوق محفوظة.",
      startAssessment: "بدء التقييم",
      contact: "اتصل بالدعم"
    }
  },
  he: {
    hero: {
      title: "מיון רפואי מבוסס AI לכולם, בכל מקום",
      subtitle: "טיבבי עוזר לספקי שירותי בריאות לספק הערכות מטופלים מהירות ומדויקות יותר ביותר מ-30 שפות, מקצר זמני המתנה ומשפר את איכות הטיפול ברחבי העולם.",
      whatsapp: "צ'אט בוואטסאפ",
      messenger: "צ'אט במסנג'ר",
      badges: {
        hipaa: "תואם HIPAA",
        trusted: "מהימן ל-100+ ספקים"
      }
    },
    stats: {
      timeReduction: "הפחתת זמן מיון",
      accuracy: "דיוק אבחון",
      availability: "זמין",
      languages: "שפות"
    },
    features: {
      title: "למה ספקי בריאות בוחרים בטיבבי",
      subtitle: "שנה את הפרקטיקה שלך עם אוטומציה חכמה",
      triage: {
        title: "מיון חכם",
        description: "כלי הערכה מבוסס AI ששואל את השאלות הנכונות, אוסף היסטוריה רפואית מקיפה של המטופל בשפה המועדפת עליו."
      },
      efficiency: {
        title: "חסוך זמן יקר",
        description: "הפחת את זמן הקליטה ב-50% תוך הבטחה שלא יחמיץ מידע קריטי. התמקד בטיפול במטופלים, לא בניירת."
      },
      multilingual: {
        title: "שבור מחסומי שפה",
        description: "תקשר בצורה חלקה עם מטופלים ביותר מ-30 שפות כולל ערבית, עברית, צרפתית, אנגלית, ספרדית, סינית ועוד. מושלם לקהילות גלובליות מגוונות."
      },
      secure: {
        title: "מאובטח ותואם",
        description: "פלטפורמה תואמת HIPAA עם אבטחה ברמת ארגון. נתוני המטופלים שלך מוצפנים ומוגנים בכל עת."
      }
    },
    providerCTA: {
      title: "האם ספק הבריאות שלך משתמש בטיבבי?",
      subtitle: "עזור לרופא שלך לחסוך זמן ולספק טיפול טוב יותר עם מיון מבוסס AI",
      button: "הפנה את הספק שלך - קבל קרדיט של $50",
      incentive: "✨ הרווח $50 כשהספק שלך נרשם!"
    },
    howItWorks: {
      title: "איך טיבבי עובד",
      steps: [
        {
          title: "המטופל מתחיל הערכה",
          description: "מטופלים מתחילים את ההערכה הבריאותית שלהם בשפה המועדפת עליהם דרך ממשק פשוט ומודרך."
        },
        {
          title: "AI אוסף מידע",
          description: "ה-AI שלנו שואל שאלות המשך רלוונטיות, מבטיח איסוף נתונים מקיף מבלי להעמיס על המטופל."
        },
        {
          title: "הספק סוקר סיכום",
          description: "ספקי שירותי בריאות מקבלים סיכום מובנה וניתן לפעולה, מוכן לקבלת החלטות קליניות מיידיות."
        }
      ]
    },
    footer: {
      copyright: "© 2024 טיבבי. כל הזכויות שמורות.",
      startAssessment: "התחל הערכה",
      contact: "צור קשר עם תמיכה"
    }
  },
  fr: {
    hero: {
      title: "Triage médical alimenté par l'IA pour tous, partout",
      subtitle: "Tibbbi aide les prestataires de soins de santé à fournir des évaluations de patients plus rapides et plus précises dans plus de 30 langues, réduisant les temps d'attente et améliorant la qualité des soins dans le monde entier.",
      whatsapp: "Discuter sur WhatsApp",
      messenger: "Discuter sur Messenger",
      badges: {
        hipaa: "Conforme HIPAA",
        trusted: "Approuvé par 100+ Prestataires"
      }
    },
    stats: {
      timeReduction: "Réduction du temps de triage",
      accuracy: "Précision du diagnostic",
      availability: "Disponible",
      languages: "Langues"
    },
    features: {
      title: "Pourquoi les prestataires de soins choisissent Tibbbi",
      subtitle: "Transformez votre pratique avec l'automatisation intelligente",
      triage: {
        title: "Triage intelligent",
        description: "Outil d'évaluation alimenté par l'IA qui pose les bonnes questions, recueillant un historique médical complet du patient dans sa langue préférée."
      },
      efficiency: {
        title: "Économisez un temps précieux",
        description: "Réduisez le temps d'admission de 50% tout en garantissant qu'aucune information critique n'est manquée. Concentrez-vous sur les soins aux patients, pas sur la paperasse."
      },
      multilingual: {
        title: "Brisez les barrières linguistiques",
        description: "Communiquez facilement avec les patients dans plus de 30 langues incluant l'arabe, l'hébreu, le français, l'anglais, l'espagnol, le mandarin et plus. Parfait pour les communautés mondiales diverses."
      },
      secure: {
        title: "Sécurisé et conforme",
        description: "Plateforme conforme HIPAA avec sécurité de niveau entreprise. Les données de vos patients sont chiffrées et protégées à tout moment."
      }
    },
    providerCTA: {
      title: "Votre prestataire de soins utilise-t-il Tibbbi?",
      subtitle: "Aidez votre médecin à gagner du temps et à fournir de meilleurs soins avec le triage alimenté par l'IA",
      button: "Référez votre prestataire - Obtenez 50$ de crédit",
      incentive: "✨ Gagnez 50$ lorsque votre prestataire s'inscrit!"
    },
    howItWorks: {
      title: "Comment fonctionne Tibbbi",
      steps: [
        {
          title: "Le patient commence l'évaluation",
          description: "Les patients commencent leur évaluation de santé dans leur langue préférée via une interface simple et guidée."
        },
        {
          title: "L'IA collecte les informations",
          description: "Notre IA pose des questions de suivi pertinentes, garantissant une collecte de données complète sans surcharger le patient."
        },
        {
          title: "Le prestataire examine le résumé",
          description: "Les prestataires de soins de santé reçoivent un résumé structuré et exploitable, prêt pour une prise de décision clinique immédiate."
        }
      ]
    },
    footer: {
      copyright: "© 2024 Tibbbi. Tous droits réservés.",
      startAssessment: "Commencer l'évaluation",
      contact: "Contacter le support"
    }
  },
  es: {
    hero: {
      title: "Triaje sanitario impulsado por IA para todos, en cualquier lugar",
      subtitle: "Tibbbi ayuda a los proveedores de salud a ofrecer evaluaciones más rápidas y precisas en más de 30 idiomas, reduciendo los tiempos de espera y mejorando la calidad de la atención en todo el mundo.",
      whatsapp: "Chatear en WhatsApp",
      messenger: "Chatear en Messenger",
      badges: {
        hipaa: "Cumple con HIPAA",
        trusted: "De confianza por más de 100 proveedores"
      }
    },
    stats: {
      timeReduction: "Reducción del tiempo de triaje",
      accuracy: "Precisión diagnóstica",
      availability: "Disponible",
      languages: "Idiomas"
    },
    features: {
      title: "Por qué los proveedores de salud eligen Tibbbi",
      subtitle: "Transforma tu práctica con automatización inteligente",
      triage: {
        title: "Triaje inteligente",
        description: "Herramienta de evaluación impulsada por IA que hace las preguntas correctas, y recopila un historial médico completo en el idioma preferido del paciente."
      },
      efficiency: {
        title: "Ahorra tiempo valioso",
        description: "Reduce el tiempo de admisión en un 50% asegurando que no se pierda información crítica. Enfócate en el cuidado del paciente, no en el papeleo."
      },
      multilingual: {
        title: "Rompe las barreras del idioma",
        description: "Comunícate sin problemas con los pacientes en más de 30 idiomas incluyendo árabe, hebreo, francés, inglés, español, mandarín y más. Perfecto para comunidades globales diversas."
      },
      secure: {
        title: "Seguro y conforme",
        description: "Plataforma compatible con HIPAA con seguridad a nivel empresarial. Los datos de tus pacientes están encriptados y protegidos en todo momento."
      }
    },
    providerCTA: {
      title: "¿Tu proveedor de salud usa Tibbbi?",
      subtitle: "Ayuda a tu médico a ahorrar tiempo y proporcionar mejor atención con el triaje impulsado por IA",
      button: "Recomienda a tu proveedor - Obtén una tarjeta de regalo de $50",
      incentive: "✨ Gana $50 cuando tu proveedor se registre"
    },
    howItWorks: {
      title: "Cómo funciona Tibbbi",
      steps: [
        {
          title: "El paciente inicia la evaluación",
          description: "Los pacientes comienzan su evaluación de salud en su idioma preferido a través de una interfaz guiada y simple."
        },
        {
          title: "La IA recopila información",
          description: "Nuestra IA hace preguntas de seguimiento relevantes, asegurando una recolección de datos completa sin abrumar al paciente."
        },
        {
          title: "El proveedor revisa el resumen",
          description: "Los proveedores reciben un resumen estructurado y accionable listo para tomar decisiones clínicas de inmediato."
        }
      ]
    },
    footer: {
      copyright: "© 2024 Tibbbi. Todos los derechos reservados.",
      startAssessment: "Iniciar evaluación",
      contact: "Contactar soporte"
    }
  },
  de: {
    hero: {
      title: "KI-gestützte Gesundheits-Triage für alle, überall",
      subtitle: "Tibbbi hilft Gesundheitsdienstleistern, schnellere und genauere Patienteneinschätzungen in über 30 Sprachen bereitzustellen, verkürzt Wartezeiten und verbessert die Qualität der Versorgung weltweit.",
      whatsapp: "Auf WhatsApp chatten",
      messenger: "Auf Messenger chatten",
      badges: {
        hipaa: "HIPAA-konform",
        trusted: "Vertraut von über 100 Anbietern"
      }
    },
    stats: {
      timeReduction: "Reduzierte Triage-Zeit",
      accuracy: "Diagnosegenauigkeit",
      availability: "Verfügbar",
      languages: "Sprachen"
    },
    features: {
      title: "Warum Gesundheitsdienstleister Tibbbi wählen",
      subtitle: "Transformieren Sie Ihre Praxis mit intelligenter Automatisierung",
      triage: {
        title: "Intelligente Triage",
        description: "KI-gestütztes Bewertungstool, das die richtigen Fragen stellt, und eine umfassende Krankengeschichte des Patienten in seiner bevorzugten Sprache sammelt."
      },
      efficiency: {
        title: "Wertvolle Zeit sparen",
        description: "Reduzieren Sie die Aufnahmezeit um 50 %, während Sie sicherstellen, dass keine wichtigen Informationen fehlen. Konzentrieren Sie sich auf die Patientenversorgung, nicht auf Papierkram."
      },
      multilingual: {
        title: "Sprachbarrieren überwinden",
        description: "Kommunizieren Sie nahtlos mit Patienten in über 30 Sprachen, darunter Arabisch, Hebräisch, Französisch, Englisch, Spanisch, Mandarin und mehr. Perfekt für vielfältige globale Gemeinschaften."
      },
      secure: {
        title: "Sicher und konform",
        description: "HIPAA-konforme Plattform mit Sicherheit auf Unternehmensniveau. Die Daten Ihrer Patienten sind jederzeit verschlüsselt und geschützt."
      }
    },
    providerCTA: {
      title: "Verwendet Ihr Gesundheitsanbieter Tibbbi?",
      subtitle: "Helfen Sie Ihrem Arzt, Zeit zu sparen und bessere Versorgung mit KI-gestützter Triage zu bieten",
      button: "Empfehlen Sie Ihren Anbieter – erhalten Sie eine 50$-Geschenkkarte",
      incentive: "✨ Verdienen Sie 50$, wenn sich Ihr Anbieter registriert!"
    },
    howItWorks: {
      title: "Wie Tibbbi funktioniert",
      steps: [
        {
          title: "Der Patient startet die Bewertung",
          description: "Patienten beginnen ihre Gesundheitsbewertung in ihrer bevorzugten Sprache über eine einfache, geführte Benutzeroberfläche."
        },
        {
          title: "Die KI sammelt Informationen",
          description: "Unsere KI stellt relevante Folgefragen und stellt sicher, dass eine umfassende Datenerfassung erfolgt, ohne den Patienten zu überfordern."
        },
        {
          title: "Der Anbieter überprüft die Zusammenfassung",
          description: "Gesundheitsdienstleister erhalten eine strukturierte, umsetzbare Zusammenfassung, die sofort für klinische Entscheidungen bereit ist."
        }
      ]
    },
    footer: {
      copyright: "© 2024 Tibbbi. Alle Rechte vorbehalten.",
      startAssessment: "Bewertung starten",
      contact: "Support kontaktieren"
    }
  },
  hi: {
    hero: {
      title: "हर किसी के लिए, हर जगह एआई-संचालित स्वास्थ्य ट्रायेज",
      subtitle: "Tibbbi स्वास्थ्य प्रदाताओं को 30+ भाषाओं में तेज़ और अधिक सटीक रोगी मूल्यांकन प्रदान करने में मदद करता है, प्रतीक्षा समय कम करता है और दुनिया भर में देखभाल की गुणवत्ता में सुधार करता है।",
      whatsapp: "WhatsApp पर चैट करें",
      messenger: "Messenger पर चैट करें",
      badges: {
        hipaa: "HIPAA अनुरूप",
        trusted: "100+ प्रदाताओं द्वारा भरोसेमंद"
      }
    },
    stats: {
      timeReduction: "ट्रायेज समय में कमी",
      accuracy: "नैदानिक ​​सटीकता",
      availability: "उपलब्ध",
      languages: "भाषाएँ"
    },
    features: {
      title: "स्वास्थ्य प्रदाता Tibbbi क्यों चुनते हैं",
      subtitle: "बुद्धिमान ऑटोमेशन के साथ अपने अभ्यास को बदलें",
      triage: {
        title: "बुद्धिमान ट्रायेज",
        description: "एआई-संचालित मूल्यांकन उपकरण जो सही प्रश्न पूछता है, और रोगी का पूर्ण चिकित्सा इतिहास उनकी पसंदीदा भाषा में एकत्र करता है।"
      },
      efficiency: {
        title: "मूल्यवान समय बचाएं",
        description: "स्वीकृति समय को 50% तक घटाएं और सुनिश्चित करें कि कोई भी महत्वपूर्ण जानकारी छूट न जाए। कागजी कार्य नहीं, रोगी देखभाल पर ध्यान केंद्रित करें।"
      },
      multilingual: {
        title: "भाषा बाधाओं को तोड़ें",
        description: "अरबी, हिब्रू, फ्रेंच, अंग्रेजी, स्पेनिश, मंदारिन और अन्य सहित 30+ भाषाओं में रोगियों के साथ आसानी से संवाद करें। विविध वैश्विक समुदायों के लिए बिल्कुल सही।"
      },
      secure: {
        title: "सुरक्षित और अनुपालक",
        description: "HIPAA-अनुरूप मंच जिसमें उद्यम-स्तरीय सुरक्षा है। आपके मरीज के डेटा हमेशा एन्क्रिप्टेड और सुरक्षित रहते हैं।"
      }
    },
    providerCTA: {
      title: "क्या आपका स्वास्थ्य प्रदाता Tibbbi का उपयोग करता है?",
      subtitle: "एआई-संचालित ट्रायेज के साथ अपने डॉक्टर को समय बचाने और बेहतर देखभाल देने में मदद करें",
      button: "अपने प्रदाता को रेफर करें – 50$ गिफ्ट कार्ड प्राप्त करें",
      incentive: "✨ जब आपका प्रदाता साइन अप करता है तो 50$ कमाएँ!"
    },
    howItWorks: {
      title: "Tibbbi कैसे काम करता है",
      steps: [
        {
          title: "मरीज़ मूल्यांकन शुरू करता है",
          description: "मरीज अपनी पसंदीदा भाषा में एक सरल, निर्देशित इंटरफ़ेस के माध्यम से अपना स्वास्थ्य मूल्यांकन शुरू करते हैं।"
        },
        {
          title: "एआई जानकारी एकत्र करता है",
          description: "हमारी एआई प्रासंगिक अनुवर्ती प्रश्न पूछती है, रोगी पर बोझ डाले बिना पूर्ण डेटा संग्रह सुनिश्चित करती है।"
        },
        {
          title: "प्रदाता सारांश की समीक्षा करता है",
          description: "स्वास्थ्य प्रदाता एक संरचित, क्रियान्वित सारांश प्राप्त करते हैं, जो तत्काल क्लिनिकल निर्णय लेने के लिए तैयार है।"
        }
      ]
    },
    footer: {
      copyright: "© 2024 Tibbbi. सर्वाधिकार सुरक्षित.",
      startAssessment: "मूल्यांकन शुरू करें",
      contact: "सहायता से संपर्क करें"
    }
  },
  zh: {
    hero: {
      title: "面向所有人、随时随地的 AI 驱动医疗分诊",
      subtitle: "Tibbbi 帮助医疗提供者用 30 多种语言提供更快速、更准确的患者评估，缩短等待时间并提高全球护理质量。",
      whatsapp: "在 WhatsApp 上聊天",
      messenger: "在 Messenger 上聊天",
      badges: {
        hipaa: "符合 HIPAA",
        trusted: "100+ 家提供者的信赖"
      }
    },
    stats: {
      timeReduction: "分诊时间缩短",
      accuracy: "诊断准确率",
      availability: "可用",
      languages: "语言"
    },
    features: {
      title: "医疗服务提供者选择 Tibbbi 的理由",
      subtitle: "用智能自动化改变你的实践",
      triage: {
        title: "智能分诊",
        description: "AI 驱动的评估工具，提出正确的问题，以患者偏好的语言收集全面的病史。"
      },
      efficiency: {
        title: "节省宝贵时间",
        description: "在确保不遗漏任何关键信息的同时，将接诊时间缩短 50%。专注于患者护理，而不是文书工作。"
      },
      multilingual: {
        title: "打破语言障碍",
        description: "支持包括阿拉伯语、希伯来语、法语、英语、西班牙语、普通话等在内的 30 多种语言，帮助您与患者无障碍沟通。适用于多元的全球社区。"
      },
      secure: {
        title: "安全合规",
        description: "HIPAA 合规平台，具有企业级安全性。您的患者数据始终被加密并受到保护。"
      }
    },
    providerCTA: {
      title: "您的医疗提供者在使用 Tibbbi 吗？",
      subtitle: "用 AI 驱动的分诊帮助您的医生节省时间并提供更好的护理",
      button: "推荐您的提供者 - 获得 50 美元礼品卡",
      incentive: "✨ 当您的提供者注册时，可获得 50 美元奖励！"
    },
    howItWorks: {
      title: "Tibbbi 如何运作",
      steps: [
        {
          title: "患者开始评估",
          description: "患者通过简单的引导界面，以他们偏好的语言开始健康评估。"
        },
        {
          title: "AI 收集信息",
          description: "我们的 AI 提出相关的后续问题，确保完整的数据收集而不使患者感到负担。"
        },
        {
          title: "提供者审阅总结",
          description: "医疗提供者收到结构化且可操作的摘要，可立即用于临床决策。"
        }
      ]
    },
    footer: {
      copyright: "© 2024 Tibbbi。保留所有权利。",
      startAssessment: "开始评估",
      contact: "联系支持"
    }
  }
};